import { GetAddressAutoCompleteResponse, GetPlaceDetailResponse, SaveAddressPayload } from '@/types'
import { useMutation, useQuery } from '@tanstack/react-query'
import httpService from './httpService'

const addressPath = '/address/v1.0'

export const enum ADDRESS_QUERY_KEY {
  GET_ADDRESS_AUTOCOMPLETE = 'get_address_autocomplete',
}

export const useGetAddressAutocomplete = (query: string, sessionId: string) => {
  return useQuery(
    [ADDRESS_QUERY_KEY.GET_ADDRESS_AUTOCOMPLETE],
    async () => {
      const res = await httpService.Get<GetAddressAutoCompleteResponse>(
        `${addressPath}/autocomplete?q=${query}&st=${sessionId}`
      )
      return res.result
    },
    {
      enabled: query !== '*',
    }
  )
}

export const getPlaceDetail = async (placeId: string) => {
  return await httpService.Get<GetPlaceDetailResponse>(`${addressPath}/details?placeId=${placeId}`)
}

// regionsOnly: suggest only cities/counties/states/postcodes/countries — for a person's own location.
export const getAddressAutocomplete = async (query: string, sessionId: string, regionsOnly = false) => {
  return await httpService.Get<GetAddressAutoCompleteResponse>(
    `${addressPath}/autocomplete?q=${query}&st=${sessionId}${regionsOnly ? '&regionsOnly=true' : ''}`
  )
}

export const useSaveAddress = () => {
  return useMutation(async (payload: SaveAddressPayload) => {
    const res = await httpService.Put(`${addressPath}/save`, payload)
    return res.result
  })
}

export const saveAddress = async (payload: SaveAddressPayload) => {
  return await httpService.Put(`${addressPath}/save`, payload)
}
